import React, {Component} from 'react';
import {Modal, Table} from 'react-bootstrap';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';

var Config = require('../../../config');

class ModalAuth extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.onSave = this.onSave.bind(this);
		this.handleChange = this.handleChange.bind(this);

		this.state = {
			show: false,
			user:"",
			pass:"",
			unit_id:"",
			type:"",
			screen:"",
			donor_id:"",
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		if(e.target.value !== ""){
			this.showInputError(e.target.name);
		}
	}

	handleShow(id, type, screen){
		if(screen === 'hc' || screen === 'ext'){
			this.setState({screen:screen, donor_id:id, show:true, user:"", pass:""});

		}else if(screen === 'laboratory'){
			this.setState({
				show:true,
				screen:'laboratory',
				unit_id:id,
				type:type,
				user:sessionStorage.getItem('user_name'),
				pass:""
			});
		}else{
			this.setState({
				show: true,
				unit_id:id,
				type:type,
				screen:"",
				pass:""
			});
		}

		setTimeout(()=>{
			document.getElementById('pass').value = "";
		}, 300);
			
			
	}

	handleClose(){
		this.setState({
			show: false,
			unit_id:"",
			type:"",
			screen:"",
			user:"",
		});
	}

	isValidForm() {
		const select = document.querySelector('div.modal-body');
  		const inputs = select.querySelectorAll('input');
	    //const inputs = document.querySelectorAll('input');
	    let isFormValid = true;
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.showInputError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });	  
	    
	    return isFormValid;
	}

	showInputError(refName) {
		const control = document.getElementById(refName);
		
		if(control.value === ""){
			if(control !== null){
	            control.classList.add('error');
	        }
			return false;
		}else{
			if(control.className.includes('error')){
				control.classList.remove('error');
			}
			return true;
		}
	}

	onSave(e){
		if(this.isValidForm()){
			var password = btoa(this.state.pass);
			password = password.split("").reverse().join("");

			var apiUrl = 'users/urgency_authorization?user='+this.state.user+'&pwd='+password;
			if(this.state.screen === 'laboratory'){
				apiUrl = 'users/change_authorization?user='+this.state.user+'&pwd='+password+'&id='+this.state.unit_id;
			}

			var obj = null;
			if(this.state.screen === 'hc' || this.state.screen === 'ext'){
				obj = {
					username:this.state.user,
					password:password
				};

				apiUrl = 'users/verify_pass';
			}
			
			this.props.waiting.handleShow('Autorizando...');
			fetch(Config.default.apiGateway.URL+apiUrl,{
				method:'POST',
				body: obj !== null ? JSON.stringify(obj) : null,
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					
					if(this.state.screen === 'laboratory'){
						if(response.message === ""){

							this.handleClose();
							this.props.saveReason(this.state.type);
						}else if(response.mensaje === "sin_procesos"){
							this.handleClose();
							//this.props.saveReason(this.state.type);
							this.props.saving(response.message, this.state.type);
						}else{
							this.props.saving(response.message, this.state.type);
							this.handleClose();
								
						}
						
					}else if(this.state.screen === 'hc'){
						
						this.props.goToHc(e, this.props.offers_id, this.state.donor_id);
						this.handleClose();
						this.props.handleClose();
					}else if(this.state.screen === 'ext'){
						var caller_id = undefined;
						var donation_id = "";
						var extraction_incident_id = "";
					
						this.props.offers.res.map((v, i)=>{
							if(v.caller !== null){
								if(v.caller.offers_id === this.props.offers_id){
									caller_id 				= v.caller.id;
									donation_id 			= v.donation_id;
									extraction_incident_id 	= v.extraction_incident_id;
								}
							}else{
								if(v.offers_id === this.props.offers_id){
									donation_id 			= v.donation_id;
									extraction_incident_id 	= v.extraction_incident_id;
								}
							}
						});

						this.props.goToEx(e, this.props.offers_id, this.state.donor_id, donation_id, extraction_incident_id,caller_id);	
						this.handleClose();
						this.props.handleClose();
					}else{
					
						this.props.saving(this.state.unit_id);
						this.handleClose();
						//this.props.saving(e, this.state.unit_id, this.state.type);	
					}		
				}
			})
			
		}else{
			swal('Error', 'Campos incompletos', 'error');
		}	
	}

	render(){
		const {t} = this.props;
		return (
			<Modal show={this.state.show} onHide={this.handleClose}>
				<Modal.Header>
					<Modal.Title>Autorización</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row">
						<div className="col-xs-12">
							<div className="col-xs-12 col-sm-8 col-sm-offset-2">
								<div className="col-xs-12">
									<span className="span-min">Usuario</span>
									<input type="text" name="user" id="user" value={this.state.user || ""} disabled={this.state.screen === 'laboratory'}
										onChange={this.handleChange} className="form-control" autoComplete="none" required/>
									
								</div>
								<div className="col-xs-12">
									<span className="span-min">Contraseña</span>
									<input type="password" name="pass" id="pass" value={this.state.pass}
										onChange={this.handleChange} className="form-control" autoComplete="none" required/>
								</div>
							</div>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<FlatButton primary={true} label={t('content.generics.buttons.save')} 
						onClick={this.onSave} /> 
					<FlatButton primary={true} label={t('content.generics.buttons.close')} 
						onClick={this.handleClose} /> 
				</Modal.Footer>
			</Modal>
		)
			
	}
}

export default translate('translations') (ModalAuth)